/** Tipi condivisi dalle pagine Utenti, scheda utente e destinatari delle comunicazioni. */
export type ApprovalStatus = 'Pending' | 'Approved' | 'Rejected' | 'Suspended';

export interface AdminUserListItem {
    id: number;
    email: string;
    displayName?: string;
    role: string;
    persona?: string;
    approvalStatus: ApprovalStatus;
    approvedAt?: string;
    rejectedReason?: string;
    createdAt?: string;
    lastLoginAt?: string;
    profileCompleted: boolean;
    isActive: boolean;
    companyName?: string;
    authProvider?: string;
    isOnline?: boolean;
    enabledToolCount?: number;
    lastActivityAt?: string;
}

export interface AdminUserDetail extends AdminUserListItem {
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    city?: string;
    country?: string;
    preferredLanguage: string;
    profileUpdatedAt?: string;
    approvedByEmail?: string;
    enabledTools: { toolId: number; toolCode: string; toolName: string; visibility: string }[];
    toolUsage: { toolId: number; toolCode: string; toolName: string; count: number; lastUsedAt: string }[];
    dailyUsage: { date: string; count: number }[];
    recentActivity: { toolId: number; toolCode: string; toolName: string; usedAt: string; durationSeconds?: number }[];
    reports: { id: number; toolId: number; toolName: string; type: string; title: string; status: string; createdAt: string }[];
    messagesTargeted: number;
    messagesRead: number;
}

export interface UserToolAccess {
    toolId: number;
    toolCode: string;
    toolName: string;
    toolType: string;
    audience: string;
    visibility: string;
    isEnabled: boolean;
}

export const APPROVAL_BADGE: Record<ApprovalStatus, string> = {
    Pending: 'bg-warning',
    Approved: 'bg-success',
    Rejected: 'bg-danger',
    Suspended: 'bg-secondary',
};

export const APPROVAL_LABEL: Record<ApprovalStatus, string> = {
    Pending: 'In attesa',
    Approved: 'Approvato',
    Rejected: 'Rifiutato',
    Suspended: 'Sospeso',
};

export const PERSONA_LABEL: Record<string, string> = {
    BusinessUser: 'Utente business',
    FunctionalConsultant: 'Consulente funzionale',
    Developer: 'Sviluppatore',
    Admin: 'Amministratore',
    Auditor: 'Auditor',
};

export const AUTH_PROVIDER_LABEL: Record<string, string> = {
    Microsoft: 'Microsoft',
    Google: 'Google',
    GitHub: 'GitHub',
    Email: 'Email e password',
    Password: 'Email e password',
};
